import { Image, Modal, Text, TouchableOpacity, View } from "react-native";
import React, { useEffect, useState } from "react";

import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";

import { toast } from "react-toastify";
import { respondToChallenge } from "../../../../../services/eventsAPI";
import { handleApiError } from "../../../../../services/errorHandler";
import { AppFontStyle } from "../../../../../styles/AppFontStyle";
import { AppImages } from "../../../../../utility/AppImages";
import { AppColors } from "../../../../../utility/AppColors";
import { ShowLoader } from "../../../../../common/ShowLoader";

export default function ChallengeConfirmationModal(props) {
  const {
    showModal = false,
    setShowModal,
    isAccepted,
    challengeID,
    accessToken,
    onConfirmPress,
  } = props;

  const onCloseClick = () => {
    setShowModal(false);
  };

  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [showCreateLoader, setCreateShowLoader] = useState(false);

  const callChallengeAcceptAPI = async () => {
    setCreateShowLoader(true);

    const bodyParams = {
      accessToken: accessToken,
      challengeID: challengeID,
      response: true,
    };

    try {
      const data = await respondToChallenge(bodyParams);

      setCreateShowLoader(false);

      if (data.statusCode === 200) {
        if (data.statusCode === 200 || data.statusCode === 201) {
          toast.success("Challenge Accepted Successfully");
          onConfirmPress(true);
          setShowModal(false);
        } else {
          handleApiError(data.statusCode, data.body.error);
        }
      } else {
        handleApiError(data.statusCode);
      }
    } catch (error) {
      setCreateShowLoader(false);
      toast.error(error.message);
    }
  };

  function setAcceptedFalse() {
    onConfirmPress(false);
    setShowModal(false);
  }

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <View style={styles.mainView}>
          <View>
            <Text
              style={[AppFontStyle.BOLD_ANYBODY_32, styles.headerText]}
              onPress={onCloseClick}
            >
              {isAccepted ? "Challenge Confirmation" : "Challenge declined"}
            </Text>
            <View style={styles.divider} />

            <View>
              <Text style={[AppFontStyle.REGULAR_ANYBODY_16, styles.titleText]}>
                {isAccepted
                  ? "Are you ready to confirm the challenge of the battle"
                  : "Leave the game"}
              </Text>

              <View style={styles.userWrapper}>
                <View style={styles.singleUserWrapper}>
                  <Image
                    source={AppImages.imgUserChallenge}
                    style={{
                      height: 75,
                      width: 75,
                      resizeMode: "contain",
                    }}
                  />
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_16,
                      {
                        color: AppColors.white,
                        paddingHorizontal: 20,
                        paddingTop: 16,
                      },
                    ]}
                  >
                    Me
                  </Text>
                </View>
                <Image
                  source={AppImages.icVsLogo}
                  style={{
                    height: 55,
                    width: 55,
                    resizeMode: "contain",
                  }}
                />
                <View style={styles.singleUserWrapper}>
                  <Image
                    source={AppImages.imgUserChallenge}
                    style={{
                      height: 75,
                      width: 75,
                      resizeMode: "contain",
                    }}
                  />
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_16,
                      {
                        color: AppColors.white,
                        paddingHorizontal: 20,
                        paddingTop: 16,
                      },
                    ]}
                  >
                    Jacob
                  </Text>
                </View>
              </View>

              <View style={styles.footerText}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_16,
                    {
                      color: AppColors.white,
                    },
                  ]}
                >
                  {isAccepted
                    ? " If you are ready to send challenge, click on confirm"
                    : "Explore more challenges or return to the dashboard"}
                </Text>
              </View>

              <TouchableOpacity
                style={styles.buttonConfirm}
                onPress={() => {
                  isAccepted ? callChallengeAcceptAPI() : setAcceptedFalse();
                }}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_12,
                    {
                      color: AppColors.white,
                    },
                  ]}
                >
                  {isAccepted ? "Confirm challenge" : "Go to dashboard"}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
        {showCreateLoader && <ShowLoader showIndicater={showCreateLoader} />}
      </View>
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      width: "35%",
      height: "60%",
      backgroundColor: AppColors.black_121212,
      paddingHorizontal: 30,
      margin: 30,
      alignSelf: "center",
      borderRadius: 12,
    },
    headerText: {
      color: AppColors.white,
      paddingHorizontal: 10,
      textAlign: "center",
      paddingTop: 25,
    },
    divider: {
      height: 2,
      marginTop: 16,
      alignSelf: "center",
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: "95%",
    },
    titleText: {
      color: AppColors.white,
      paddingHorizontal: 35,
      paddingTop: 16,
    },
    userWrapper: {
      flexDirection: "row",
      marginTop: 30,
      justifyContent: "space-between",
      marginHorizontal: 25,
    },
    singleUserWrapper: {
      flexDirection: "column",
      rowGap: 10,
    },
    footerText: {
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      paddingHorizontal: 35,
      paddingVertical: 16,
      borderRadius: 10,
      marginTop: 25,
    },
    buttonConfirm: {
      backgroundColor: AppColors.appGreenColor_51AF07,
      paddingHorizontal: 20,
      paddingVertical: 22,
      borderRadius: 10,
      justifyContent: "center",
      alignItems: "center",
      marginVertical: 25,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "45%",
        height: "60%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      headerText: {
        color: AppColors.white,
        paddingHorizontal: 10,
        textAlign: "center",
        paddingTop: 25,
      },
      divider: {
        height: 2,
        marginTop: 16,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "95%",
      },
      titleText: {
        color: AppColors.white,
        paddingHorizontal: 35,
        paddingTop: 16,
      },
      userWrapper: {
        flexDirection: "row",
        marginTop: 30,
        justifyContent: "space-between",
        marginHorizontal: 25,
      },
      singleUserWrapper: {
        flexDirection: "column",
        rowGap: 10,
      },
      footerText: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 35,
        paddingVertical: 16,
        borderRadius: 10,
        marginTop: 25,
      },
      buttonConfirm: {
        backgroundColor: AppColors.appGreenColor_51AF07,
        paddingHorizontal: 20,
        paddingVertical: 22,
        borderRadius: 10,
        justifyContent: "center",
        alignItems: "center",
        marginVertical: 25,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "55%",
        height: "60%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      headerText: {
        color: AppColors.white,
        paddingHorizontal: 10,
        textAlign: "center",
        paddingTop: 25,
      },
      divider: {
        height: 2,
        marginTop: 16,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "95%",
      },
      titleText: {
        color: AppColors.white,
        paddingHorizontal: 35,
        paddingTop: 16,
      },
      userWrapper: {
        flexDirection: "row",
        marginTop: 30,
        justifyContent: "space-between",
        marginHorizontal: 25,
      },
      singleUserWrapper: {
        flexDirection: "column",
        rowGap: 10,
      },
      footerText: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 35,
        paddingVertical: 16,
        borderRadius: 10,
        marginTop: 25,
      },
      buttonConfirm: {
        backgroundColor: AppColors.appGreenColor_51AF07,
        paddingHorizontal: 20,
        paddingVertical: 22,
        borderRadius: 10,
        justifyContent: "center",
        alignItems: "center",
        marginVertical: 25,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "65%",
        height: "60%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      headerText: {
        color: AppColors.white,
        paddingHorizontal: 10,
        textAlign: "center",
        paddingTop: 25,
      },
      divider: {
        height: 2,
        marginTop: 16,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "95%",
      },
      titleText: {
        color: AppColors.white,
        paddingHorizontal: 35,
        paddingTop: 16,
      },
      userWrapper: {
        flexDirection: "row",
        marginTop: 30,
        justifyContent: "space-between",
        marginHorizontal: 25,
      },
      singleUserWrapper: {
        flexDirection: "column",
        rowGap: 10,
      },
      footerText: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 35,
        paddingVertical: 16,
        borderRadius: 10,
        marginTop: 25,
      },
      buttonConfirm: {
        backgroundColor: AppColors.appGreenColor_51AF07,
        paddingHorizontal: 20,
        paddingVertical: 22,
        borderRadius: 10,
        justifyContent: "center",
        alignItems: "center",
        marginVertical: 25,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "95%",
        height: "60%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      headerText: {
        color: AppColors.white,
        paddingHorizontal: 10,
        textAlign: "center",
        paddingTop: 25,
      },
      divider: {
        height: 2,
        marginTop: 16,
        alignSelf: "center",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "95%",
      },
      titleText: {
        color: AppColors.white,
        paddingHorizontal: 35,
        paddingTop: 16,
      },
      userWrapper: {
        flexDirection: "row",
        marginTop: 30,
        justifyContent: "space-between",
        marginHorizontal: 25,
      },
      singleUserWrapper: {
        flexDirection: "column",
        rowGap: 10,
      },
      footerText: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 35,
        paddingVertical: 16,
        borderRadius: 10,
        marginTop: 25,
      },
      buttonConfirm: {
        backgroundColor: AppColors.appGreenColor_51AF07,
        paddingHorizontal: 20,
        paddingVertical: 22,
        borderRadius: 10,
        justifyContent: "center",
        alignItems: "center",
        marginVertical: 25,
      },
    },
  }
);
